import clsx from 'clsx'
import numeral from 'numeral'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {AppConfig} from '../../../../AppConfig'
import {trans} from '../../../../helpers'
import {useUserData} from '../../../../hooks'

interface MyAdsMoneyEarnedProps {
    className?: string
    mobile?: boolean
    topNavMenu?: boolean
}

// Блок отображения суммы выручки из объявлений.
export function CabinetMoneyEarnedCard(props: MyAdsMoneyEarnedProps) {

    const {
        className,
        mobile,
    } = props

    const user = useUserData()

    if (
        AppConfig.features?.myAds?.profitCalculation === false
        || !user?.moneyEarned
        || user.moneyEarned <= 0.0
    ) {
        return null
    }

    return (
        <Card
            className={clsx(
                'amount-earned depth-2-solid p-3',
                'd-flex align-items-center justify-content-start',
                mobile
                    ? 'amount-earned-mobile flex-row-reverse text-end'
                    : 'flex-row justify-content-start text-start',
                className
            )}
        >
            <div className="coin" />
            <div className="amount-earned-texts">
                <div className="amount">
                    {numeral(user.moneyEarned).format()}
                </div>
                <div className="subtitle text-muted">
                    {trans().cabinet.ads.money_earned}
                </div>
            </div>
        </Card>
    )
}
